import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  'status.ACTIVE': {
    id: 'license.props.status.value.active.label',
    description: 'Label for license prop status value ACTIVE',
    defaultMessage: 'Active',
  },
  'status.DEACTIVATED': {
    id: 'license.props.status.value.deactive.label',
    description: 'Label for license prop status value DEACTIVATED',
    defaultMessage: 'Deactivated',
  },
  'status.DELETED': {
    id: 'license.props.status.value.deleted.label',
    description: 'Label for license prop status value DELETED',
    defaultMessage: 'Deleted',
  },
  'status.ENDED': {
    id: 'license.props.status.value.ended.label',
    description: 'Label for license prop status value ENDED',
    defaultMessage: 'Ended',
  },
  'status.PENDING': {
    id: 'license.props.status.value.pending.label',
    description: 'Label for license prop status value PENDING',
    defaultMessage: 'Pending',
  },
  'status.UPDATED': {
    id: 'license.props.status.value.updated.label',
    description: 'Label for license prop status value UPDATED',
    defaultMessage: 'Updated',
  },
  'status.UPGRADED': {
    id: 'license.props.status.value.upgraded.label',
    description: 'Label for license prop status value UPGRADED',
    defaultMessage: 'Upgraded',
  },
  'status.REFUNDED': {
    id: 'license.props.status.value.refunded.label',
    description: 'Label for license prop status value REFUNDED',
    defaultMessage: 'Refunded',
  },
  'status.CREDIT_LOSS': {
    id: 'license.props.status.value.creditLoss.label',
    description: 'Label for license prop status value CREDIT_LOSS',
    defaultMessage: 'Credit loss',
  },
  'continuous.true': {
    id: 'license.props.continuous.value.true.label',
    description: 'Label for license prop continuous value true',
    defaultMessage: 'Yes',
  },
  'continuous.false': {
    id: 'license.props.continuous.value.false.label',
    description: 'Label for license prop continuous value false',
    defaultMessage: 'No',
  },
  'endDate.continuous': {
    id: 'license.props.endDate.value.continuous.label',
    description: 'Label for license prop end date value CONTINUOUS',
    defaultMessage: 'License is continuous',
  },
});
